import {paginatorGetter, timeGetter} from "@/1_webapi/helpers";
import {KeywordListQuery, KeywordStatsQuery} from "@/1_webapi/query";
import {checkConditions} from "@/2_app-logic/utils/utils";
import {api} from "@/main";

export default {
    namespaced: true,
    actions: {
        async fetchKeywordStats(ctx, payload = {}) {
            await api.keywordStats.fetchList(ctx.state.domains.keywordStats, payload.keyword)
        },
        async fetchKeyword(ctx, payload = {}) {
            ctx.state.domains.keyword.query.setQueryParam({key: 'keyword', value: payload.keyword})
            await api.keywords.fetchList(ctx.state.domains.keyword)
        },
        async changePage(ctx, page) {
            await api.keywordStats.changePage(ctx.state.domains.keywordStats, page)
        },
        async changePageSize(ctx, size) {
            await api.keywordStats.changePageSize(ctx.state.domains.keywordStats, size)
        },
        async sortBy(ctx, payload) {
            await api.keywordStats.sortBy(ctx.state.domains.keywordStats, payload)
        },
    },
    mutations: {
    },
    state: {
        domains: {
            keywordStats: {
                query: new KeywordStatsQuery(true, {
                    page: 1,
                    page_size: 10,
                }),
            },
            keyword: {
                query: new KeywordListQuery(),
            }
        }
    },
    getters: {
        stats(state) {
            const response = state.domains.keywordStats.query.response
            if (checkConditions([response])) {
                return response.data.branches
            }
        },
        time(state) {
            return timeGetter(state.domains.keywordStats.query)
        },
        paginator(state) {
            return paginatorGetter(state.domains.keywordStats.query)
        },
        keyword(state) {
            const query = state.domains.keyword.query
            const result = query.response && query.response.data.keywords[0]
            return result ? result : {}
        }
    },
}